module.exports = __webpack_public_path__ + "img/iconNotification.6ea1cddf.png";